module.exports = __webpack_public_path__ + "static/media/Lumisizer.e9a94673.png";